import script from "./purchasedCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./purchasedCourse.vue?vue&type=script&setup=true&lang=js"

import "./purchasedCourse.vue?vue&type=style&index=0&id=b0cf4c50&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0cf4c50"]])

export default __exports__